import { TuneIcon, IconButton, Picker } from '@gogame/components';

export function getOptionValue(opt) {
  return opt?.metricId;
}

function getOptionLabel(opt) {
  return opt?.displayName;
}

const MAX_SELECTED_METRICS = 5;

function isOptionDisabled(opt, selected) {
  return selected?.length >= MAX_SELECTED_METRICS && !selected.includes(opt);
}

const MetricsPicker = ({ options, onChange, selectedOptions }) => {
  return (
    <Picker
      chaneStrategy={'close'}
      selectedOptions={selectedOptions}
      isOptionDisabled={isOptionDisabled}
      button={
        <IconButton
          badgeColor={'primary'}
          badge={selectedOptions?.length}
          icon={<TuneIcon />}
          tooltip={'Metrics'}
        />
      }
      getOptionLabel={getOptionLabel}
      getOptionValue={getOptionValue}
      onChange={onChange}
      options={options}
      markSelectedOption={true}
      showCheckbox={true}
      canDeselect={true}
      closeOnSelect={false}
    />
  );
};

export default MetricsPicker;
